export default "__VITE_ASSET__9946fe4f__"